var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1",
    "data-name": "\\uC0AC\\uAC01\\uD615 1",
    width: 35,
    height: 42,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uBCA1\\uD130_\\uACE0\\uAE09_\\uAC1C\\uCCB4",
    "data-name": "\\uBCA1\\uD130 \\uACE0\\uAE09 \\uAC1C\\uCCB4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_17",
    "data-name": "\\uADF8\\uB8F9 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_16",
    "data-name": "\\uADF8\\uB8F9 16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16",
    "data-name": "\\uD328\\uC2A4 16",
    d: "M25.579,41.783h0a.8.8,0,0,0,.544-.213l8.5-7.912a.774.774,0,0,0,.242-.564A.9.9,0,0,0,35,32.622V3.314A3.338,3.338,0,0,0,31.646,0H3.355A3.338,3.338,0,0,0,0,3.314V38.687A3.337,3.337,0,0,0,3.355,42h21.63a.93.93,0,0,0,.595-.217m.8-2.6v-3.04a2.292,2.292,0,0,1,2.3-2.275h3.4Zm-2.321.976H3.355a1.486,1.486,0,0,1-1.492-1.474V3.314A1.486,1.486,0,0,1,3.355,1.84H31.646a1.485,1.485,0,0,1,1.493,1.474V31.7H28.791a4.713,4.713,0,0,0-4.737,4.678Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M7.248,12.224h20.5a.925.925,0,0,0,.931-.919V9.657a.925.925,0,0,0-.931-.919H7.248a.925.925,0,0,0-.931.919V11.3a.925.925,0,0,0,.931.919M7.434,9.84H27.566V11.12H7.434Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_18",
    "data-name": "\\uD328\\uC2A4 18",
    d: "M7.248,17.988h20.5a.925.925,0,0,0,.931-.92V15.421a.926.926,0,0,0-.931-.92H7.248a.926.926,0,0,0-.931.92v1.646a.925.925,0,0,0,.931.92M7.434,15.6H27.566v1.279H7.434Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    d: "M28.683,22.833V21.185a.925.925,0,0,0-.931-.919H7.248a.925.925,0,0,0-.931.919v1.647a.925.925,0,0,0,.931.919h20.5a.925.925,0,0,0,.931-.919m-1.117-.184H7.434V21.369H27.566Z",
    fill: "#231f20"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/일일.854638331d7967749a161b7a05c96107.svg";
export { ForwardRef as ReactComponent };